import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";

const Jump = () => {
    const location = useLocation()
    const params = useParams()
    const url = params.url
    const [outside,setOutside] = useState(false)
	useEffect(() => {
		document.querySelector("title").textContent = "確認 - ourt"
        if(!(url.startsWith("/") || url.startsWith("http://ourt-ai.work") || url.startsWith("https://ourt-ai.work"))){
            setOutside(true)
        } else {
            window.location.href = url
        }
	},[location.pathname])

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container className='text-center'>
            {outside ? (<>
                <h5>以下はアワートAIではない外部サイトです。</h5>
                <Link to={url}>{url}</Link>
            </>) : ""}
        </Container>
        <Footer />
    </div>
    )
}

export default Jump;
